import type { ExternalTableSchema } from '@packages/table-builder';
import { RSA_TRANSACTION_STATUS_BADGES } from '../rsa/schema';

/** Vest events of one RSA purchase — `RSAPurchaseId` is supplied via `staticQueryParams` by the caller. */
export const rsaVestEventsTable: ExternalTableSchema = {
  metadata: {
    title: 'Vest Events',
    entity: 'RsaVestEvent',
  },

  dataSource: {
    endpoint: '/api/award/api/app/rsa-transaction/r-sAVest-event-list',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
    },
  },

  columns: [
    { field: 'vestDate', header: 'Vest Date', type: 'date', sortable: true, width: 140 },
    { field: 'vestingShares', header: 'Vesting Shares', type: 'number', sortable: true, width: 150, align: 'center' },
    { field: 'fmv', header: 'FMV $', type: 'currency', sortable: true, width: 140, align: 'center', format: { decimals: 4 } },
    { field: 'taxableIncome', header: 'Taxable Income $', type: 'currency', sortable: true, width: 170, align: 'center', format: { decimals: 4 } },
    { field: 'totalTaxes', header: 'Total Taxes $', type: 'currency', sortable: true, width: 150, align: 'center', format: { decimals: 4 } },
    { field: 'settlementType', header: 'Settlement Type', type: 'text', sortable: true, width: 160 },
    { field: 'fundingRequired', header: 'Funding Required $', type: 'currency', sortable: true, width: 170, align: 'center', format: { decimals: 4 } },
    { field: 'fundedAmount', header: 'Funded Amount $', type: 'currency', sortable: true, width: 160, align: 'center', format: { decimals: 4 } },
    { field: 'repurchaseShares', header: 'Repurchase Shares', type: 'number', sortable: true, width: 160, align: 'center' },
    { field: 'netShares', header: 'Net Shares', type: 'number', sortable: true, width: 130, align: 'center' },
    {
      field: 'transactionStatus',
      header: 'Status',
      type: 'badge',
      sortable: true,
      width: 150,
      align: 'center',
      badge: { statusMap: RSA_TRANSACTION_STATUS_BADGES, defaultVariant: 'default' },
    },
  ],

  actions: {
    row: [{ id: 'SUMMARY_VEST_EVENT_RSA', label: 'View Details' }],
  },

  features: {
    search: { enabled: false },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    columnPreferences: { persistenceKey: 'RsaVestEvent', resizable: true, reorderable: true },
  },
};
